import { useAccessibleCard } from '@squiz/xaccel-accessibility';
import { format as formatDate } from 'date-fns';
import PropTypes from 'prop-types';
import React from 'react';
/**
 * Simple Generic Result Component.
 *
 * @param {string} clickTrackingUrl Result url with click tracker.
 * @param {string} liveUrl Plain url of the result (no click tracker).
 * @param {string} title Title of the result.
 * @param {string} indexUrl Result url stored in FB.
 * @param {string} summary Search result summary.
 * @param {number} date Document published date.
 *
 * @returns {JSX.Element}
 * @constructor
 */
function GenericResult({ clickTrackingUrl, liveUrl, title, indexUrl, summary, date }) {
    const rootClass = 'funnelback-instant-search-generic-result';
    const publishedDate = date ? formatDate(new Date(date), 'd MMM yyyy') : null;
    const { cardRef, linkRef } = useAccessibleCard();
    return (
        <article className={rootClass} ref={cardRef}>
            <div className={`${rootClass}__content`}>
                <div className={`${rootClass}__header`}>
                    <a href={clickTrackingUrl} title={liveUrl} className={`${rootClass}__title-link`} ref={linkRef}>
                        <h3 className={`${rootClass}__title`}>{title}</h3>
                    </a>
                    <cite className={`${rootClass}__subtitle ${rootClass}__subtitle--highlight`}>{indexUrl}</cite>
                </div>
                <div className={`${rootClass}__body`}>
                    {summary && <div className={`${rootClass}__summary`}>{summary}</div>}
                    {publishedDate && <div className={`${rootClass}__date-published`}>Date published: {publishedDate}</div>}
                </div>
            </div>
        </article>
    );
}
const { string, number } = PropTypes;

GenericResult.propTypes = PropTypes.shape({
    clickTrackingUrl: string,
    liveUrl: string,
    displayUrl: string,
    indexUrl: string,
    summary: string,
    title: string,
    date: number,
}).isRequired;

export default GenericResult;
